import React from "react";
import { Layout, Affix, Popover } from 'antd';
import { renderRoutes } from "react-router-config";
import styles from "./index.scss";
import MenuList from "./MenuList";
import TitleSpan from "@/components/TitleSpan";
import FooterComponent from "@/components/Footer";
import {
    SettingOutlined
} from "@ant-design/icons";
import history from "@/history";
import { clearCookie } from "@/common/request";
import local from "@/config/localstorage";
import store from "store";

import {apiLoginOut} from '../../pages/Login/model/api';

const { Header, Content, Footer } = Layout;

function PopoverContent(props: any) {
    const { onCLickUserConfig, onCLickSystemConfig, type, onLogout } = props;
    // const userRole = store.get(local.userInfo).sysRoleNames
    const isAdmin = store.get(local.userInfo).isAdmin || -1
    return (
        <div className={styles.systemConfigure}>
            <div className={type === "user" ? styles.selectActive : ""} onClick={onCLickUserConfig}>用户设置</div>
            {/* {userRole && userRole.indexOf('系统配置') > -1 && <div className={type === "system" ? styles.selectActive : ""} onClick={onCLickSystemConfig}>系统配置</div>} */}
            {isAdmin === 1 && <div className={type === "system" ? styles.selectActive : ""} onClick={onCLickSystemConfig}>系统配置</div>}
            <div onClick={onLogout}>退出登录</div>
        </div>
    );
}

let pathNum: any = 0;
class LayoutComponent extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            activityKey: "",
            type: ""
        };
    }

    onCLickUserConfig = () => {
        history.push("/system/user/config")
        this.setState(() => ({
            activityKey: `system${pathNum++}`,
            type: "user"
        }));
    }

    onCLickSystemConfig = () => {
        history.replace("/system/config")
        this.setState(() => ({
            activityKey: `system${pathNum++}`,
            type: "system"
        }));
    }

    onChangeSelect = () => {
        this.setState(() => ({
            activityKey: "",
            type: ""
        }));
    }

    onLogout = async () => {
        await apiLoginOut();
        clearCookie();
    };

    componentDidMount() {
        this.onTestClick()
        let type: string = "user";
        if (history.location.pathname.indexOf("/system/config") > -1) {
            type = "system";
        }
        this.setState(() => ({
            type
        }));
    }

    componentWillUnmount() {
        pathNum = undefined;
    }

    onTestClick() { }

    render() {
        const { route } = this.props;
        const { activityKey, type } = this.state;
        const subRoutes = route ? route.routes : [];
        return (
            <Layout className={styles.layout}>
                <Affix offsetTop={0}>
                    <Header className={styles.layoutHeader}>
                        <div className={styles.flexHeader}>
                            <div className={styles.flex6 + " " + styles.fontFamily}>
                                <div>
                                    <div className={styles.logoImage} />
                                    <div className={styles.titleText}>
                                        <TitleSpan>上海日报视频资源库</TitleSpan>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.flex8}>
                                <MenuList activityKey={activityKey} onChangeSelect={this.onChangeSelect} />
                            </div>
                            <div className={styles.flex1}>
                                <Popover placement="bottomRight" title={null} content={<PopoverContent
                                    type={type}
                                    onCLickUserConfig={this.onCLickUserConfig}
                                    onCLickSystemConfig={this.onCLickSystemConfig}
                                    onLogout={this.onLogout}
                                />} trigger="click">
                                    <div>
                                        <div>
                                            <SettingOutlined className={styles.setIcon} />
                                        </div>
                                        <div>
                                            <TitleSpan>设置</TitleSpan>
                                        </div>
                                    </div>
                                </Popover>
                            </div>
                        </div>
                    </Header>
                </Affix>
                {/* <div className={styles.layoutFixed}>
                    
                </div>
                <div className={styles.layoutFixedheader} /> */}
                <Content style={{ overflow: "auto" }}>
                    {renderRoutes(subRoutes)}
                </Content>
                <Footer>
                    <div style={{ position: "relative" }}>
                        <FooterComponent />
                    </div>
                </Footer>
            </Layout>
        );
    }
}

export default LayoutComponent;